import axios from 'axios';
import { X_TENANT_ID, UPLOADIMAGE, } from '../../common/ActionUrl';
const requestOptions = {
    headers: { 'X-TENANT-ID': X_TENANT_ID },
}

export const uploadFile = (formData) => {
    return axios.post(UPLOADIMAGE, formData, requestOptions)
}